<kbxl-shipping-load-audit-log-grid
  [loadAuditLogs]="loadAuditLogs$ | async"
  [loadingAuditLogs]="loadingAuditLogs$ | async"
></kbxl-shipping-load-audit-log-grid>
